import { useState } from "react";

import styles from "@styles/forms-flow/creative.module.scss";

import { Checkbox, Label } from "@components";

const USE_TYPES = {
  ONLINE: 1,
  OFFLINE: 2,
  TAKEAWAY: 4,
  FASTFILA: 8,
};

const isType = (haystack, needle) => (needle & haystack) >= needle;

export const PlaceBenefitUse = ({ coupon, onChangeCreative }) => {
  const [placeBenefitUse, setPlaceBenefitUse] = useState(coupon?.type_use);

  useState(() => {
    setPlaceBenefitUse(coupon?.type_use);
  }, [coupon]);

  const setType = (type) => {
    setPlaceBenefitUse(type);
    onChangeCreative({ type_use: type });
  };

  return (
    <>
      <Label>Onde o benefício poderá ser utilizado?</Label>

      <Checkbox
        family="place"
        className="mb-10"
        value={"OFFLINE"}
        checked={isType(placeBenefitUse, USE_TYPES.OFFLINE) ? "OFFLINE" : false}
        onChange={() => {
          if (isType(placeBenefitUse, USE_TYPES.OFFLINE)) {
            setType(placeBenefitUse & ~USE_TYPES.OFFLINE);
          } else {
            setType(placeBenefitUse | USE_TYPES.OFFLINE);
          }
        }}
      >
        Salão
      </Checkbox>
      <Checkbox
        family="place"
        className="mb-10"
        value={"ONLINE"}
        checked={isType(placeBenefitUse, USE_TYPES.ONLINE) ? "ONLINE" : false}
        onChange={() => {
          if (isType(placeBenefitUse, USE_TYPES.ONLINE)) {
            setType(placeBenefitUse & ~USE_TYPES.ONLINE);
          } else {
            setType(placeBenefitUse | USE_TYPES.ONLINE);
          }
        }}
      >
        Delivery
      </Checkbox>
      <Checkbox
        family="place"
        className="mb-10"
        value={"TAKEAWAY"}
        checked={
          isType(placeBenefitUse, USE_TYPES.TAKEAWAY) ? "TAKEAWAY" : false
        }
        onChange={() => {
          if (isType(placeBenefitUse, USE_TYPES.TAKEAWAY)) {
            setType(placeBenefitUse & ~USE_TYPES.TAKEAWAY);
          } else {
            setType(placeBenefitUse | USE_TYPES.TAKEAWAY);
          }
        }}
      >
        Para viagem
      </Checkbox>
      <Checkbox
        family="place"
        value={"FASTFILA"}
        checked={
          isType(placeBenefitUse, USE_TYPES.FASTFILA) ? "FASTFILA" : false
        }
        onChange={() => {
          if (isType(placeBenefitUse, USE_TYPES.FASTFILA)) {
            setType(placeBenefitUse & ~USE_TYPES.FASTFILA);
          } else {
            setType(placeBenefitUse | USE_TYPES.FASTFILA);
          }
        }}
      >
        Consumo no local
      </Checkbox>
    </>
  );
};
